import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;

let cancelRead;
class VisitorVisitApi extends Api {
  constructor() {
    super('visitors/visits', 'visitors/visits');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const visitorVisitApi = new VisitorVisitApi();

export default visitorVisitApi;
